import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { filter, skip } from 'rxjs/operators';
import { SpaqFireDb } from './spaq-fire-db.service';

@Injectable({ providedIn: 'root' })
export class KillSwitchService {
	private started = false;
	private refreshing = false;

	constructor(
		private db: SpaqFireDb,
		private afAuth: AngularFireAuth
	) {}

	/** `path`: RTDB path holding this app's kill-switch timestamp (e.g. `/config/killSwitchCem`)
	 *  — each app passes its own value (see AppComponent.ngOnInit, environment.killSwitchPath). */
	start(path: string): void {
		if (this.started) {
			return;
		}
		this.started = true;

		// Capture early so we can cancel leave-page prompts during a forced refresh.
		window.addEventListener(
			'beforeunload',
			event => {
				if (!this.refreshing) {
					return;
				}
				event.stopImmediatePropagation();
			},
			true
		);

		this.db
			.killSwitch$(path)
			.pipe(
				filter(value => value != null),
				skip(1)
			)
			.subscribe({
				next: () => this.forceLogoutAndRefresh(),
				// Fail-open — an RTDB hiccup here shouldn't block the whole app from loading.
				error: () => undefined
			});
	}

	private forceLogoutAndRefresh(): void {
		this.silencePrompts();
		this.db.goOffline();
		this.afAuth
			.signOut()
			.catch(() => undefined)
			.finally(() => {
				window.location.replace('/');
			});
	}

	private silencePrompts(): void {
		this.refreshing = true;
		try {
			window.onbeforeunload = null;
			window.alert = () => undefined;
			window.confirm = () => true;
		} catch {
			// ignore — still proceed with logout/refresh
		}
	}
}
